/**
 * Mint a fresh StationId for a newly-created station.
 *
 * Prefers crypto.randomUUID (universally available in modern browsers and
 * Node 19+). Falls back to a v4-shaped composite from Math.random for
 * environments where crypto.randomUUID is missing (theoretical: keeps the
 * type-checker happy without forcing every caller to write the fallback).
 */
import { StationId } from '@/domain/types';

export function newStationId(): StationId {
  if (typeof globalThis !== 'undefined' && globalThis.crypto?.randomUUID) {
    return StationId.of(globalThis.crypto.randomUUID());
  }
  const hex = (): string =>
    Math.floor(Math.random() * 0xffff)
      .toString(16)
      .padStart(4, '0');
  return StationId.of(
    `${hex()}${hex()}-${hex()}-4${hex().slice(1)}-8${hex().slice(1)}-${hex()}${hex()}${hex()}`,
  );
}
